<template>
  <div style="height: 100%; width: 100%; overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="merchantId"
      :columns="columns"
      :queryParams="queryParams"
      :enableSearch="false"
      :operationBoxStyle="{ padding: '0 0 16px' }"
      :requestPromise="loadDataList"
    >
      <template v-slot:operation>
        <a-button type="primary" icon="plus" @click="onCreate">新建</a-button>
        <a-button icon="reload" @click="onRefresh">刷新</a-button>
      </template>

      <template v-slot:status="{ record }">
        <span v-if="Number(record.status) === 1">已开启</span>
        <span v-else-if="Number(record.status) === 0">已禁用</span>
        <span v-else-if="Number(record.status) === -1">已删除</span>
        <span v-else>{{ statusTextMap[record.status] || record.status || '-' }}</span>
      </template>

      <template v-slot:markupPoints="{ record }">
        {{ record.markupPoints != null ? `${record.markupPoints}%` : '-' }}
      </template>

      <template v-slot:flatFen="{ text }">
        {{ formatFlatYuan(text) }}
      </template>

      <template v-slot:updateTime="{ text }">
        {{ formatTime(text) }}
      </template>

      <template v-slot:action="{ record }">
        <a-space v-if="Number(record.status) !== -1">
          <a @click="onEditMarkup(record)">编辑加价</a>
          <a v-if="Number(record.status) === 1" @click="onDisable(record)">禁用</a>
          <a v-else-if="Number(record.status) === 0" @click="onEnable(record)">启用</a>
          <a @click="onDelete(record)">删除</a>
        </a-space>
        <span v-else>-</span>
      </template>
    </StandardSearchPageView>

    <related-account-create-dialog
      :visible.sync="createVisible"
      @success="onRefresh"
    />
    <related-account-edit-markup-dialog
      :visible.sync="editMarkupVisible"
      :record="editRecord"
      @success="onRefresh"
    />
  </div>
</template>

<script>
import moment from 'moment'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import RelatedAccountCreateDialog from './RelatedAccountCreateDialog.vue'
import RelatedAccountEditMarkupDialog from './RelatedAccountEditMarkupDialog.vue'

export default {
  name: 'RelatedAccountsComponent',
  components: {
    StandardSearchPageView,
    RelatedAccountCreateDialog,
    RelatedAccountEditMarkupDialog
  },
  data() {
    return {
      createVisible: false,
      editMarkupVisible: false,
      editRecord: null,
      queryParams: {},
      statusTextMap: {
        0: '未开通',
        1: '已开通',
        2: '已禁用'
      },
      columns: [
        { title: '商户ID', dataIndex: 'merchantId', width: 140 },
        {
          title: '状态',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '加价百分点',
          dataIndex: 'markupPoints',
          width: 120,
          scopedSlots: { customRender: 'markupPoints' }
        },
        {
          title: '固定加价(元)',
          dataIndex: 'flatFen',
          width: 130,
          scopedSlots: { customRender: 'flatFen' }
        },
        { title: '备注', dataIndex: 'remark', width: 200 },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 180,
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 160,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    formatTime(value) {
      if (!value) return '-'
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value
    },
    /** 接口返回分 → 列表按元展示 */
    formatFlatYuan(fen) {
      if (fen == null || fen === '') return '-'
      const fenNum = Number(fen)
      if (!Number.isFinite(fenNum)) return '-'
      return String(fenNum / 100)
    },
    /**
     * GET /hkdl/config/admin/managers/self
     * 返回当前登录商户自己的配置（单条或空）；表格组件需要 { totalCount, pageCount, data }
     */
    loadDataList() {
      return this.getHttpServices()
        .getSourceService()
        .get('/hkdl/config/admin/managers/self')
        .then(res => {
          if (!res) {
            return { totalCount: 0, pageCount: 0, data: [] }
          }
          const list = Array.isArray(res) ? res : [res]
          const data = list.filter(item => item && item.merchantId != null)
          return {
            totalCount: data.length,
            pageCount: data.length > 0 ? 1 : 0,
            data
          }
        })
    },
    onCreate() {
      this.createVisible = true
    },
    onRefresh() {
      this.$refs.table && this.$refs.table.refresh(true)
    },
    onEditMarkup(record) {
      this.editRecord = record || null
      this.editMarkupVisible = true
    },
    /**
     * POST /hkdl/config/admin/managers/{merchantId}/disable
     */
    onDisable(record) {
      if (!record || record.merchantId == null) return
      this.$confirm({
        title: `确定禁用商户「${record.merchantId}」吗？`,
        content: '禁用后将失去配置资格，名下产品/套餐会一并下架。',
        onOk: () => {
          return this.getHttpServices()
            .getSourceService()
            .post(`/hkdl/config/admin/managers/${record.merchantId}/disable`)
            .then(() => {
              this.$message.success('禁用成功')
              this.onRefresh()
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '禁用失败，请重试')
            })
        }
      })
    },
    /**
     * POST /hkdl/config/admin/managers/{merchantId}/enable
     */
    onEnable(record) {
      if (!record || record.merchantId == null) return
      this.$confirm({
        title: `确定启用商户「${record.merchantId}」吗？`,
        content: '启用后将恢复配置资格，原软删产品/套餐可重新上架。',
        onOk: () => {
          return this.getHttpServices()
            .getSourceService()
            .post(`/hkdl/config/admin/managers/${record.merchantId}/enable`)
            .then(() => {
              this.$message.success('启用成功')
              this.onRefresh()
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '启用失败，请重试')
            })
        }
      })
    },
    /**
     * DELETE /hkdl/config/admin/managers/{merchantId}
     * 墓碑删除：status=-1 占号不复用，名下产品/套餐一并下架，不可恢复
     */
    onDelete(record) {
      if (!record || record.merchantId == null) return
      this.$confirm({
        title: `确定删除商户「${record.merchantId}」吗？`,
        content: '删除后不可恢复：商户将永久禁用（status=-1），名下所有产品/套餐会一并下架。',
        okType: 'danger',
        onOk: () => {
          return this.getHttpServices()
            .getSourceService()
            .delete(`/hkdl/config/admin/managers/${record.merchantId}`)
            .then(() => {
              this.$message.success('删除成功')
              this.onRefresh()
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '删除失败，请重试')
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
